export interface SelectOptionForPaste {
  readonly label: string;
  readonly value: string | undefined;
}

/**
 * Resolves pasted clipboard text to a select option. Used by grid paste so unknown
 * or header text does not throw and the rest of the paste can continue.
 * Optional `normalizePasted` maps free-text (e.g. nationality or gender synonyms) to a stored option value.
 */
export function resolvePastedSelectOption(
  options: readonly SelectOptionForPaste[],
  pastedRaw: string | undefined,
  normalizePasted?: (value: string) => string | undefined,
): SelectOptionForPaste | undefined {
  if (pastedRaw == null) {
    return undefined;
  }
  const pasted = pastedRaw.trim();
  const byLabel = options.find((o) => (o.label ?? "").trim() === pasted);
  if (byLabel !== undefined) {
    return byLabel;
  }
  if (pasted === "") {
    return undefined;
  }
  const normalized = normalizePasted?.(pasted);
  if (normalized !== undefined && normalized !== "") {
    const byNormalized = options.find((o) => o.value !== undefined && o.value === normalized);
    if (byNormalized !== undefined) {
      return byNormalized;
    }
  }
  return options.find((o) => o.value !== undefined && o.value === pasted);
}
